import React, { Fragment, memo, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

// Utils

import styled from "styled-components";

import IcCheckOff from "../../../resources/images/icon/checkbox/checkbox_default.svg";
import IcCheckDisable from "../../../resources/images/icon/checkbox/checkbox_disable.svg";
import IcCheckOn from "../../../resources/images/icon/checkbox/checkbox_select.svg";

import NothingImg from "../../../resources/images/icon/icon_medicine_list.png";
import IcSliderNor from "../../../resources/images/icon/trtmtData/card/Icon_trtmt_submenu_off.svg";
import IcSliderActive from "../../../resources/images/icon/trtmtData/card/Icon_trtmt_submenu_on.svg";
import Card3 from "./Components/Card/Card3";
import Card1 from "./Components/Card/card1";

export default memo((props) => {
  // srchType - true : 병원공유 가능 상태, false - 병원신청 가능 상태
  const { srchType, setSrchType, setDeleteData, dataList, periodIndex } = props;
  const [checkAll, setCheckAll] = useState(false);
  const [checkedDataArr, setCheckedDataArr] = useState([]);

  const [aprvDataList, setAprvDataList] = useState([]);
  const [existingDataList, setExistingDataList] = useState([]);

  // 페이징 처리
  const { ref, inView } = useInView();

  const clickedToggle = () => {
    setSrchType((prev) => !prev);
    setCheckAll(false);
  };

  const checkAllToggle = () => {
    setCheckAll((prev) => !prev);

    if (!checkAll) {
      let checkArr = new Array();

      $("input[name=checkSeqNo]").each(function () {
        checkArr.push($(this).attr("id"));
      });

      props.setSelectDataArray(checkArr);
    } else {
      props.setSelectDataArray([]);
      $("input[name=checkSeqNo]").prop("checked", false);
    }
  };

  useEffect(() => {
    if (checkAll) {
      $("input[name=checkSeqNo]").prop("checked", true);
      $("input[name=checkAll]").prop("checked", true);
    } else {
      $("input[name=checkAll]").prop("checked", false);
    }
  }, [checkAll]);

  useEffect(() => {
    // 필터링 전 초기화
    setAprvDataList([]);
    setExistingDataList([]);
    // 필터링
    dataList.filter(function (data, index) {
      if (data.newYn === "Y") {
        setAprvDataList((aprvDataList) => [...aprvDataList, data]);
      } else {
        setExistingDataList((existingDataList) => [...existingDataList, data]);
      }
    });
  }, [dataList]);

  return (
    <Fragment>
      {dataList.length > 0 ? (
        <List>
          {aprvDataList.length > 0 && (
            <Fragment>
              <ListHeader style={{ display: "flex", marginBottom: "0px" }}>
                <Fragment>
                  {/* <div onClick={srchType ? ()=>checkAllToggle() : ""}> */}
                  {/* <div onClick={()=> {srchType ? checkAllToggle() : ""}}> */}
                  <div>
                    {/* <ItemCheckedAll type={"checkbox"} name={"checkAll"} checkAll={checkAll} on={'true'} disabled={srchType ? false : true} /> */}
                    <SelectAllText>새로운 자료</SelectAllText>
                    {/* <SelectAllSubText>  {"*"} 1주일 이후 진료일별 자료에서 제공됩니다.</SelectAllSubText> */}
                  </div>

                  {aprvDataList.length > 0 ||
                  (!!srchType && aprvDataList.length === 0) ? (
                    srchType ? (
                      // 병원공유 가능 상태
                      <RequestDataLayer onClick={() => clickedToggle()}>
                        <IsChecked on="false">
                          <RequestIcon>
                            <RequestImg src={IcSliderActive} alt="" />
                          </RequestIcon>
                          <RequestedData on="false">병원공유</RequestedData>
                        </IsChecked>
                      </RequestDataLayer>
                    ) : (
                      // 병원신청 가능 상태
                      <RequestDataLayer onClick={() => clickedToggle()}>
                        <IsChecked on="true">
                          <RequestIcon>
                            <RequestImg src={IcSliderNor} alt="" />
                          </RequestIcon>
                          <RequestedData on="true">병원공유</RequestedData>
                        </IsChecked>
                      </RequestDataLayer>
                    )
                  ) : (
                    <Fragment />
                  )}
                </Fragment>
              </ListHeader>

              <SelectAllSubText style={{ paddingLeft: "0px" }}>
                {" "}
                {"*"} 1주일 이후 진료일별 자료에서 제공됩니다.
              </SelectAllSubText>
            </Fragment>
          )}

          {aprvDataList.length > 0 && (
            <Fragment>
              {aprvDataList.map((m, i) =>
                m.dataType === "U" ? (
                  <Card1
                    key={"list" + i}
                    data={m}
                    dataList={aprvDataList}
                    setLocationInfo={props.setLocationInfo}
                    setSelectDataArray={props.setSelectDataArray}
                    setDeleteData={setDeleteData}
                    srchType={srchType}
                    setCheckAll={setCheckAll}
                  />
                ) : (
                  <Card3
                    key={"list" + i}
                    data={m}
                    dataList={aprvDataList}
                    setLocationInfo={props.setLocationInfo}
                    setSelectDataArray={props.setSelectDataArray}
                    setDeleteData={setDeleteData}
                    srchType={srchType}
                    setCheckAll={setCheckAll}
                  />
                )
              )}
              <div ref={ref} />
            </Fragment>
          )}

          <ListHeader style={{ display: "flex", marginBottom: "8px" }}>
            {existingDataList.length > 0 && (
              <Fragment>
                <div>
                  <SelectAllText>진료일별 자료</SelectAllText>
                </div>

                {/* {aprvDataList.length > 0 || (!!srchType && aprvDataList.length===0) */}
                {aprvDataList.length === 0 && existingDataList.length > 0 ? (
                  srchType ? (
                    // 병원공유 가능 상태
                    <RequestDataLayer onClick={() => clickedToggle()}>
                      <IsChecked on="false">
                        <RequestIcon>
                          <RequestImg src={IcSliderActive} alt="" />
                        </RequestIcon>
                        <RequestedData on="false">병원공유</RequestedData>
                      </IsChecked>
                    </RequestDataLayer>
                  ) : (
                    // 병원신청 가능 상태
                    <RequestDataLayer onClick={() => clickedToggle()}>
                      <IsChecked on="true">
                        <RequestIcon>
                          <RequestImg src={IcSliderNor} alt="" />
                        </RequestIcon>
                        <RequestedData on="true">병원공유</RequestedData>
                      </IsChecked>
                    </RequestDataLayer>
                  )
                ) : (
                  <Fragment />
                )}
              </Fragment>
            )}
          </ListHeader>

          {existingDataList.length > 0 && (
            <Fragment>
              {existingDataList.map((m, i) =>
                m.dataType === "U" ? (
                  <Card1
                    key={"existingDataList" + i}
                    data={m}
                    dataList={existingDataList}
                    setLocationInfo={props.setLocationInfo}
                    setSelectDataArray={props.setSelectDataArray}
                    setDeleteData={setDeleteData}
                    srchType={srchType}
                    setCheckAll={setCheckAll}
                  />
                ) : (
                  <Card3
                    key={"existingDataList" + i}
                    data={m}
                    dataList={existingDataList}
                    setLocationInfo={props.setLocationInfo}
                    setSelectDataArray={props.setSelectDataArray}
                    setDeleteData={setDeleteData}
                    srchType={srchType}
                    setCheckAll={setCheckAll}
                  />
                )
              )}
              <div ref={ref} />
            </Fragment>
          )}
        </List>
      ) : (
        <Fragment>
          {aprvDataList.length == 0 ? (
            srchType ? (
              // 병원공유 가능 상태
              <RequestDataLayer onClick={() => clickedToggle()}>
                <IsChecked on="false">
                  <RequestIcon>
                    <RequestImg src={IcSliderActive} alt="" />
                  </RequestIcon>
                  <RequestedData on="false">병원공유</RequestedData>
                </IsChecked>
              </RequestDataLayer>
            ) : (
              // 병원신청 가능 상태
              <RequestDataLayer onClick={() => clickedToggle()}>
                <IsChecked on="true">
                  <RequestIcon>
                    <RequestImg src={IcSliderNor} alt="" />
                  </RequestIcon>
                  <RequestedData on="true">병원공유</RequestedData>
                </IsChecked>
              </RequestDataLayer>
            )
          ) : (
            <Fragment />
          )}

          <Nothing srchType={srchType} />
        </Fragment>
      )}
    </Fragment>
  );
});

const Nothing = (props) => {
  const { srchType } = props;

  return (
    <div className="nothing-box">
      <div>
        <img src={NothingImg} alt="" />
        <p>
          {srchType ? "공유할 자료가 없습니다." : "등록된 자료가 없습니다."}
          <br />
        </p>
      </div>
    </div>
  );
};
/* css */

const List = styled.div`
  /* // padding:30px 20px; */
  padding: 0px 5px;
`;

const ListHeader = styled.div`
  width: 100%;
  height: 22px;
  line-height: 22px;

  vertical-align: middle;
  // margin-bottom: 8px;
`;
const ItemCheckedAll = styled.input`
  appearance: none !important;
  display: inline-block;
  background: url(${(props) => (props.disabled ? IcCheckDisable : IcCheckOff)});
  background-color: #fff !important;
  width: 18px;
  height: 18px;

  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const SelectAllText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;

  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;
`;

const SelectAllSubText = styled.div`
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 16px;
  color: #6a62e6;

  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;

  padding-left: 8px;
`;

const RequestDataLayer = styled.div`
  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;
  margin-left: auto;

  float: right;
`;

const RequestIcon = styled.div`
  display: inline-block;
  box-sizing: border-box;
  float: right;
  vertical-align: middle;
`;

const RequestImg = styled.img`
  display: inline-block;
  box-sizing: border-box;

  margin-left: 8px;
  margin-right: 8px;
  vertical-align: middle;
  padding-bottom: 2px;
`;

const IsChecked = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 22px;

  background: ${(props) => (props.on === "false" ? "#6A62E6" : "#FFFFFF")};
  border: 1px solid #6a62e6;
  border-radius: 6px;
`;

const RequestedData = styled.div`
  font-weight: 700;
  font-size: 12px;
  color: ${(props) => (props.on === "false" ? "#FFFFFF" : "#6A62E6")};
  margin-right: 8px;
`;

const ListItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  // gap: 85px;

  position: relative;
  width: 100%;
  height: 120px;
  margin: 0 0 12px 0; // 위, 오른쪽, 아래, 왼쪽

  background: #ffffff;
  border: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
  border-radius: 8px;
`;

const ListItemInfoLayer = styled.div`
  width: 100%;
  height: 80px;
  display: inline-block;
  flex-direction: row;
  // border: 1px solid #FF0000;

  // border-bottom:1px solid #6A62E6;
  border-bottom: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const LineOneLayer = styled.div`
  width: 100%;
  // height: 21.33px;
  height: 46px;
  line-height: 46px;
`;

const ItemChecked = styled.div`
  width: 18px;
  height: 18px;

  // position: absolute;
  // left: 0%;
  // right: 0%;
  // top: 0%;
  // bottom: 0%;

  margin-left: 20px;
  margin-right: 10px;
  // margin-top: 13.67px;

  background: ${(props) => (props.on === "true" ? "#FFFFFF" : "#D9D9D9")};
  border: 1px solid ${(props) => (props.on === "true" ? "#C9C9C9" : "#D9D9D9")};
  border-radius: 2px;

  vertical-align: middle;

  display: inline-block;
  box-sizing: border-box;
`;

const ItemDate = styled.div`
  // font-family: 'Pretendard';
  // font-style: normal;
  // font-weight: 400;
  // font-size: 14px;

  color: #000000;

  display: inline-block;
  text-align: center;
  box-sizing: border-box;
`;

const ItemHospital = styled.div`
  // font-family: 'Pretendard';
  // font-style: normal;
  // font-weight: 400;
  // font-size: 14px;

  max-width: 127px;

  margin-right: 12px;
  color: #000000;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
`;

const Img = styled.img`
  // vertical-align:middle;

  // display: inline-block;
  // box-sizing: border-box;
  // float: right;
  vertical-align: middle;
  padding-bottom: 3px;
`;

const ItemMap = styled.div`
  margin-right: 20px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
`;

const LineTwoLayer = styled.div`
  // height: 46px;
  display: inline-block;
  box-sizing: border-box;

  line-height: 22px;
  margin: 0 19px 0 48px;

  vertical-align: middle;
`;

const ContentText = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;

  margin-left: 10px;
  margin-right: 8px;

  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ListButtonLayer = styled.div`
  width: 100%;
  height: 38px;
  line-height: 38px;
`;

const LeftButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;
`;

const RightButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;

  // border-left:1px solid #6A62E6;
  border-left: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const ButtonText = styled.div`
  display: inline-block;
  box-sizing: border-box;

  margin-left: 4px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;
